function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLinesWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 748.318 132.3",
    style: {
      enableBackground: "new 0 0 748.318 132.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1.841,0.55h19.703c1.017,0,1.841,0.824,1.841,1.841v104.83c0,1.017,0.824,1.841,1.841,1.841H84.22   c1.017,0,1.841,0.824,1.841,1.841v18.769c0,1.017-0.824,1.841-1.841,1.841H1.841c-1.017,0-1.841-0.824-1.841-1.841V2.391   C0,1.374,0.824,0.55,1.841,0.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M164.993,0.55h20.248c1.017,0,1.841,0.824,1.841,1.841v127.281c0,1.017-0.824,1.841-1.841,1.841   h-20.248c-1.017,0-1.841-0.824-1.841-1.841V2.391C163.152,1.374,163.976,0.55,164.993,0.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M280.589,0.55h18.753c0.578,0,1.123,0.272,1.471,0.734l67.739,90.004V2.391   c0-1.017,0.824-1.841,1.841-1.841h19.703c1.017,0,1.841,0.824,1.841,1.841v127.281c0,1.017-0.824,1.841-1.841,1.841h-18.572   c-0.578,0-1.122-0.271-1.469-0.732l-67.92-90.006v88.897c0,1.017-0.824,1.841-1.841,1.841h-19.703   c-1.017,0-1.841-0.824-1.841-1.841V2.391C278.748,1.374,279.572,0.55,280.589,0.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M483.601,20.599V2.391c0-1.017,0.824-1.841,1.841-1.841h90.798c1.017,0,1.841,0.824,1.841,1.841   V21.16c0,1.017-0.824,1.841-1.841,1.841h-90.174C484.323,23.001,483.601,21.975,483.601,20.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M487.166,52.935h74.106c1.017,0,1.841,0.824,1.841,1.841v18.769c0,1.017-0.824,1.841-1.841,1.841   h-52.445c-1.017,0-1.841,0.824-1.841,1.841v29.994c0,1.017,0.824,1.841,1.841,1.841h69.281c1.017,0,1.841,0.824,1.841,1.841v18.769   c0,1.017-0.824,1.841-1.841,1.841h-92.666c-1.017,0-1.841-0.824-1.841-1.841V55.815C483.601,53.706,484.965,52.935,487.166,52.935z   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M656.208,111.138l12.767-12.764c0.746-0.746,1.939-0.743,2.656,0.032   c3.393,3.67,13.705,13.052,30.472,13.052c14.498,0,22.653-8.154,22.653-17.218c0-25.372-65.243-11.779-65.243-57.994   C659.513,17.218,676.73,0,703.917,0c22.536,0,35.732,11.835,39.584,15.881c0.698,0.733,0.663,1.866-0.052,2.581l-12.768,12.768   c-0.735,0.735-1.908,0.746-2.628-0.004c-2.991-3.12-11.33-10.382-24.136-10.382c-13.593,0-20.843,7.249-20.843,15.404   c0,25.372,65.243,11.783,65.243,57.994c0,19.937-18.123,38.06-46.215,38.06c-26.716,0-41.86-14.15-45.969-18.609   C655.461,112.962,655.506,111.84,656.208,111.138z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLinesWhite);
export default __webpack_public_path__ + "static/media/logo-lines-white.971a7d86c88eb88245145ef637bb1bbd.svg";
export { ForwardRef as ReactComponent };